import { create } from "zustand";
import { createVideoMetadataSlice } from "./slices/videoMetadata/videoMetadata";
import { createDocumentMetadataSlice } from "./slices/documentMetadata/documentMetadata";
import { Store } from "./types";
import { createMetadataSlice } from "./slices/mandatoryMetaData/mandatoryMetadata";
import { devtools } from "zustand/middleware";

export const useStore = create<Store>()(
  devtools(
    (set, get, store) => ({
      ...createVideoMetadataSlice(set, get, store),
      ...createDocumentMetadataSlice(set, get, store),
      ...createMetadataSlice(set, get, store),
    }),
    { name: "uploader-store" },
  ),
);
